//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { MembershipPlanDisplayItem } from './MembershipPlanDisplayItem';
import { MembershipPlanCurrencyCode } from './Enums';

export class MembershipTransactionDisplayItem extends ItemBase {
    Account: string | null = null;
    AccountHolderName: string | null = null;
    AddressLine1: string | null = null;
    AddressLine2: string | null = null;
    City: string | null = null;
    Country: string | null = null;
    CurrencyCode: MembershipPlanCurrencyCode = MembershipPlanCurrencyCode.AUD;
    Date: string = "1970-01-01T00:00:00";
    ID: string | null = null;
    PaymentSourceBrand: string | null = null;
    PostalCode: string | null = null;
    ProvinceCode: string | null = null;
    TaxAmount: number = 0;
    TaxRate: number = 0;
    TotalAmount: number = 0;
    TransactionID: string | null = null;
    Plan: MembershipPlanDisplayItem | null = null;
    Note: string | null = null;
    PlanID: string | null = null;

    constructor(initializer?: Partial<MembershipTransactionDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "MembershipTransactionDisplayItem";
}
